import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ApiService } from "src/app/services/api.service";
import { ProjectData } from "src/app/models/projectdata";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Store } from "src/app/helpers/store";
import { DomSanitizer } from "@angular/platform-browser";
import { DialogService } from "src/app/services/dialog.service";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  id: string;
  projectData: ProjectData = null;

  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  thirdFormGroup: FormGroup;
  fourthFormGroup: FormGroup;

  title = "Kundenzufriedenheit";
  subtitle = "Projekt:";
  backMsg = "Zurück";
  nextMsg = "Nächste";
  sendMsg = "Absenden";
  placeholderMsg = "Nachricht hier eingeben...";

  q1;
  q2;
  q3;
  q4;
  doneHeader;
  doneMessage;
  q1Answers;
  q2Answers;
  q3Answers;

  language = "de";
  sendBtnDisabled = false;

  constructor(
    private store: Store,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private formBuilder: FormBuilder,
    private sanitizer: DomSanitizer,
    private dialogService: DialogService
  ) {}

  ngOnInit() {
    if (this.route.snapshot.paramMap.get("ID"))
      this.id = this.route.snapshot.paramMap.get("ID");
    if (this.id == null) this.leavePage();
    if (location.pathname.includes("/en/")) {
      this.language = "en";
      this.title = "Customer Survey";
      this.subtitle = "Project:";
      this.backMsg = "Back";
      this.nextMsg = "Next";
      this.sendMsg = "Send";
      this.placeholderMsg = "Enter message here...";

      this.q1 = this.store.q1En;
      this.q2 = this.store.q2En;
      this.q3 = this.store.q3En;
      this.q4 = this.store.q4En;
      this.doneHeader = this.store.doneHeaderEn;
      this.doneMessage = this.store.doneMessageEn;
      this.q1Answers = this.store.q1AnswersEn;
      this.q2Answers = this.store.q2AnswersEn;
      this.q3Answers = this.store.q3AnswersEn;
    } else {
      this.q1 = this.store.q1;
      this.q2 = this.store.q2;
      this.q3 = this.store.q3;
      this.q4 = this.store.q4;
      this.doneHeader = this.store.doneHeader;
      this.doneMessage = this.store.doneMessage;
      this.q1Answers = this.store.q1Answers;
      this.q2Answers = this.store.q2Answers;
      this.q3Answers = this.store.q3Answers;
    }

    this.firstFormGroup = this.formBuilder.group({
      radioGroup1: ["", Validators.required],
    });
    this.secondFormGroup = this.formBuilder.group({
      radioGroup2: ["", Validators.required],
    });
    this.thirdFormGroup = this.formBuilder.group({
      radioGroup3: ["", Validators.required],
    });
    this.fourthFormGroup = this.formBuilder.group({
      input: [""],
    });

    this.apiService.getCsData(this.id).subscribe((result) => {
      console.log(result);
      this.projectData = result;
      if (!this.projectData) this.leavePage();
      if (!this.projectData.open) this.leavePage(this.projectData.homepage);
      let el = window.document.head.getElementsByTagName("link")[0];
      el.href = "data:image/x-icon;base64," + this.projectData.logo;
    });
  }

  leavePage(url: string = "https://www.google.at") {
    location.href = url;
  }

  getSantizeUrl() {
    return this.sanitizer.bypassSecurityTrustUrl(
      "data:image/png;base64," + this.projectData.logo
    );
  }

  onSubmitClicked() {
    this.sendBtnDisabled = true;
    let postData = {
      csId: this.id,
      firmenNr: this.projectData.firmenNr,
      language: this.language,
      question1: this.q1,
      question2: this.q2,
      question3: this.q3,
      question4: this.q4,
      answer1: this.q1Answers.find(
        (a) => a.value == parseInt(this.firstFormGroup.value["radioGroup1"])
      ),
      answer2: this.q2Answers.find(
        (a) => a.value == parseInt(this.secondFormGroup.value["radioGroup2"])
      ),
      answer3: this.q3Answers.find(
        (a) => a.value == parseInt(this.thirdFormGroup.value["radioGroup3"])
      ),
      answer4: this.fourthFormGroup.value["input"],
    };

    this.apiService.saveCsAnswers(postData).subscribe(
      () => this.leavePage(this.projectData.homepage),
      () => {
        let header = this.language == "de" ? "Achtung" : "Attention";
        let msg =
          this.language == "de"
            ? "Es tut uns leid. Ein unerwarteter Fehler ist aufgetreten. Die IT wurde benachrichtigt."
            : "An unexpected error occured. The IT department was informed.";
        this.dialogService
          .openOkDialog(header, msg)
          .afterClosed()
          .subscribe(() => this.leavePage(this.projectData.homepage));
      }
    );
  }
}
